import { render } from "./EditParceiro.vue?vue&type=template&id=ba8ffbf0"
import script from "./EditParceiro.vue?vue&type=script&lang=js"
export * from "./EditParceiro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__